import React from 'react';
import { Grid, Card, Dropdown, Button, Icon } from 'semantic-ui-react';
import DeleteIcon from '@material-ui/icons/Delete';

export default class Item extends React.Component {

  state = {}

  componentDidMount() {
    let menu = this.props.selectedItem;
    if (menu) {
      this.props.updateItem(this.props.id, 'menu', menu);
      this.setState({
        menu: menu
      });
    }
    let type = this.props.selectedType;
    if (type) {
      this.props.updateItem(this.props.id, 'type', type);
      this.setState({
        type: type
      });
    }
    this.setExecutive();
    this.setCustomerTypes();
    this.setMenus();

  }

  setExecutive() {
    let context = this;
    var x = [];
    this.props.executives.map((y) => {
      x.push({key: y.name, text: y.name, value: y.id});
    });
    try {
      context.setState({
        executiveOption: x,
      });
    } catch (e) {}
  }

  setCustomerTypes() {
    let context = this;
    var x = [];
    this.props.customerTypes.map((y) => {
      x.push({key: y.type_name, text: y.type_name, value: y.id});
    });
    try {
      context.setState({
        customerTypeOption: x,
      });
    } catch (e) {}
  }

  setMenus() {
    let context = this;
    var x = [];
    let menu = ['Place Order', 'Order Status',  'Offers', 'Chats', 'Spares Enquiry',
                'Call Requests', 'Call Customer', 'Edit Customer', 'Transactions',
                'Reports', 'Statements', 'Quotation', 'Invoice',
                'Add Harvest', 'View Harvest', 'Buy Machine',
                'Sell Machine', 'View Machine', 'Call Logs'];
    menu.map((y) => {
      x.push({key: y, text: y, value: y});
    });
    try {
      context.setState({
        menuOption: x,
      });
    } catch (e) {}
  }

  onChange = (type) => (f, { value }) => {
    this.props.updateItem(this.props.id, type, value);
    this.setState({ [type]: value })
  }

  render() {
    const { executive, menu, type } = this.state;
    return (
      <div style={{padding: '1%'}}>
        <Grid>


          <Grid.Column mobile={16} tablet={16} computer={5}>
            Executive<br/>
            <Dropdown fluid multiple
              id="Executive" onChange={this.onChange('executive')}
              search selection options={this.state.executiveOption}
              value={executive} fluid style={{ borderColor: '#5A9CBB' }} />
          </Grid.Column>

          <Grid.Column mobile={16} tablet={16} computer={5}>
            Menu<br/>
            <Dropdown fluid multiple
              id="Menu" onChange={this.onChange('menu')}
              search selection options={this.state.menuOption}
              value={menu} fluid style={{ borderColor: '#5A9CBB' }} />
          </Grid.Column>

          <Grid.Column mobile={16} tablet={16} computer={5}>
            Customer Type<br/>
            <Dropdown fluid multiple
              id="Type" onChange={this.onChange('type')}
              search selection options={this.state.customerTypeOption}
              value={type} fluid style={{ borderColor: '#5A9CBB' }} />
          </Grid.Column>

          <Grid.Column mobile={16} tablet={16} computer={1}>
            <DeleteIcon onClick={this.props.remove(this.props.id)}
              style={{cursor: 'pointer', marginTop: 'auto', marginBottom: 'auto'}}/>
          </Grid.Column>
        </Grid>
      </div>
    );
  }

}
